import {
  OAuthProvider,
  GoogleAuthProvider,
  TwitterAuthProvider,
  FacebookAuthProvider
} from 'firebase/auth'

const appleIdProvider = new OAuthProvider('apple.com')
const googleProvider = new GoogleAuthProvider()
const twitterProvider = new TwitterAuthProvider()
const facebookProvider = new FacebookAuthProvider()

appleIdProvider.addScope('email')
googleProvider.addScope('email')
facebookProvider.addScope('email')

googleProvider.setCustomParameters({
  prompt: 'select_account'
})

export { appleIdProvider, googleProvider, twitterProvider, facebookProvider }
